import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AutoFocus from '../AutoFocus'

import panelStyle from 'Styles/panel.css'
import style from './style.css'

function getAnswer (curCard) {
  let answer
  if (curCard.testTerm) {
    answer = curCard.testTerm
  } else {
    answer = curCard.choices[curCard.correctAnswerIndex]
  }
  return answer
}

function getFeedback (curCard) {
  if (curCard.choices_fb) {
    return curCard.choices_fb[curCard.correctAnswerIndex]
  } else if (curCard.feedbackCorrect) {
    return curCard.feedbackCorrect
  }
}

export default function ShowAnswerModal (props) {
  const answer = getAnswer(props.curCard)
  const feedback = getFeedback(props.curCard)
  return (
    <div
      className={classnames(panelStyle.large, style.container)}
      data-test-id="showAnswerModal"
    >
      <AutoFocus check={answer}>
        <h2 className={style.answer}>
          Answer
        </h2>
        <h2 className={style.textInfoModal}>The correct answer is:</h2>
        <h3
          className={style.textAnswerModal}
          dangerouslySetInnerHTML={{ __html: answer }}
          data-test-id="showAnswerModalAnswer"
        />
      </AutoFocus>
      {feedback
        ? (
          <h1
            data-test-id="showAnswerModalHint"
            className={style.textInfoModal}
            dangerouslySetInnerHTML={{ __html: feedback }}
          />
          )
        : null
      }
      <div className={style.challenge}>
        <button
          onClick={props.onChallenge}
          className={classnames('btn-cdl-secondary', style.challengeContainer)}
          data-test-id="showAnswerModalBtn"
        >
          Report an error with this Question
        </button>
      </div>
    </div>
  )
}
ShowAnswerModal.propTypes = {
  curCard: PropTypes.object.isRequired,
  onChallenge: PropTypes.func.isRequired
}
